import Avatar from "components/Avatar";
import { ProgressBar } from "components/ProgressBar/ProgressBar.component";
import { Sidebar } from "components/Sidebar/Sidebar.component";
import Text from "components/Text";
import { routeConstants } from "constants/routeConstants";
import { useImageSection } from "pages/Profile/HighLight/ImageSection/useImageSection";
import { useProfileStrength } from "pages/Profile/ProfileStrength/useProfileStrength";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "slice";
import { getNameInitials } from "utils/getNameInitials";
import { useGetAgencyDataQuery } from "slice/user";
import { ProgressCard } from "../PageContent/PageContent.styled";
import * as Styled from "./CustomSidebar.styled";
import { sidebarItems } from "./sidebarItems";

export const CustomSidebar: React.FC<{ hidden: boolean }> = React.memo(
    ({ hidden }) => {
        const { images, handleError } = useImageSection(),
            { first_name, last_name, is_agency, id } = useAppSelector(
                (state) => state.user
            );
        const { pathname } = useLocation(),
            navigateTo = useNavigate(),
            { data } = useProfileStrength();
        const { selectedJobId } = useAppSelector((state) => state.jobs);

        const { data: agencyData } = useGetAgencyDataQuery(
            { user_id: id ?? "" },
            { skip: !is_agency }
        );

        let isEdit = false;
        const getSidebarItems = () => {
            if (
                pathname.includes(
                    routeConstants.profile.editProfile.agency.root
                )
            ) {
                return sidebarItems.agencyProfile;
            } else if (
                pathname.includes(routeConstants.profile.editProfile.root)
            ) {
                return sidebarItems.profile;
            } else if (pathname.includes(routeConstants.jobs.listings.root)) {
                return sidebarItems.listing;
            } else if (pathname.includes(routeConstants.findWork.findWork)) {
                return sidebarItems.findWork;
            } else if (pathname.includes(routeConstants.postJob.root)) {
                return sidebarItems.postJob;
            } else if (pathname.includes(routeConstants.editJob.root)) {
                isEdit = true;
                const editJobRoutes: any[] = [];
                sidebarItems.editJob.forEach((val) => {
                    const routes = val.route.split("/");
                    routes[3] = (
                        selectedJobId as {
                            payload: string;
                        }
                    )?.payload;
                    val.route = routes.join("/");
                    editJobRoutes.push(val);
                });
                return editJobRoutes;
            } else return sidebarItems.settings;
        };

        const showProgressCard = !pathname.includes("settings");
        return (
            <Sidebar hidden={hidden}>
                <Styled.SideBarItemsWrapper>
                    {getSidebarItems().map((item) => (
                        <Sidebar.Item
                            key={item.id}
                            title={item.title}
                            icon={item.icon}
                            onClick={() => {
                                if (!isEdit) {
                                    navigateTo(item.route);
                                } else {
                                    navigateTo(
                                        item.route.replace(
                                            ":id",
                                            (
                                                selectedJobId as {
                                                    payload: string;
                                                }
                                            )?.payload
                                        )
                                    );
                                }
                            }}
                            isActive={pathname.split("/").includes(item.id)}
                        />
                    ))}
                </Styled.SideBarItemsWrapper>
                {showProgressCard && (
                    <ProgressCard>
                        <Avatar size="S">
                            {is_agency && agencyData?.company_logo ? (
                                <img
                                    src={agencyData.company_logo}
                                    onError={handleError}
                                    alt="company logo"
                                />
                            ) : images?.profile?.url ? (
                                <img
                                    src={images?.profile?.url}
                                    onError={handleError}
                                    alt="user profile"
                                />
                            ) : (
                                <>
                                    {getNameInitials(
                                        `${first_name} ${last_name}`
                                    )}
                                </>
                            )}
                        </Avatar>
                        <Text variant="heading6">
                            Your Profile is{" "}
                            {Math.floor(data?.total_percentage || 0)}% completed
                        </Text>
                        <ProgressBar
                            progress={data?.total_percentage || 0}
                            width="100%"
                        />
                    </ProgressCard>
                )}
            </Sidebar>
        );
    }
);
